import { render } from "./BarPrice.vue?vue&type=template&id=a7001738"
import script from "./BarPrice.vue?vue&type=script&lang=js"
export * from "./BarPrice.vue?vue&type=script&lang=js"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__